import { render, staticRenderFns } from "./modal-user-login.vue?vue&type=template&id=1b20cd07&"
import script from "./modal-user-login.vue?vue&type=script&lang=js&"
export * from "./modal-user-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports